import { useState, type KeyboardEvent } from "react";
import {
  CustomerSupportIcon,
  SentIcon
} from "@hugeicons-pro/core-stroke-rounded";
import {
  IconButton,
  IconButtonSize,
  IconButtonVariant
} from "shared/components/IconButton";
import { Button, ButtonSize, ButtonVariant } from "shared/components";
import { BOOM_HELP_COPY, BOOM_HELP_MAX_MESSAGE_LENGTH } from "../constants";

const MAX_ROWS = 5;

export const Composer = ({
  onSend,
  onTalkToSupport,
  disabled,
  handingOff
}: {
  onSend: (content: string) => void;
  onTalkToSupport: () => void;
  disabled: boolean;
  handingOff: boolean;
}) => {
  const [value, setValue] = useState("");
  const content = value.trim();
  const rows = Math.min(MAX_ROWS, value.split("\n").length);

  const submit = () => {
    if (!content || disabled) return;
    onSend(content);
    setValue("");
  };

  const onKeyDown = (event: KeyboardEvent<HTMLTextAreaElement>) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      submit();
    }
  };

  return (
    <div className="space-y-2">
      <div className="flex items-end gap-2 rounded-lg border border-alpha-100 bg-white p-3 shadow-xs">
        <textarea
          id="boom-help-composer"
          aria-label={BOOM_HELP_COPY.placeholder}
          placeholder={BOOM_HELP_COPY.placeholder}
          value={value}
          rows={rows}
          maxLength={BOOM_HELP_MAX_MESSAGE_LENGTH}
          onChange={(event) => setValue(event.target.value)}
          onKeyDown={onKeyDown}
          className="max-h-[120px] min-h-10 flex-1 resize-none border-0 bg-transparent px-0 py-2 text-sm font-medium leading-6 text-content-1000 shadow-none outline-none ring-0 placeholder:text-content-200 focus:border-0 focus:outline-none focus:ring-0"
        />
        <IconButton
          aria-label="Send"
          variant={IconButtonVariant.BASE}
          size={IconButtonSize.SM}
          HugeIcon={SentIcon}
          disabled={!content || disabled}
          onClick={submit}
        />
      </div>
      <div className="flex items-center justify-between gap-3">
        <p className="text-xs text-content-300">{BOOM_HELP_COPY.disclaimer}</p>
        <Button
          variant={ButtonVariant.TEXT}
          size={ButtonSize.XS}
          HugeIcon={CustomerSupportIcon}
          loading={handingOff}
          onClick={onTalkToSupport}
          className="inline-flex shrink-0 items-center gap-1.5"
        >
          {BOOM_HELP_COPY.talkToSupport}
        </Button>
      </div>
    </div>
  );
};
